import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
	fonts: {
		heading: `'InterVariable', sans-serif`,
		body: `'InterVariable', sans-serif`,
	},
});

export default theme;
